export default "__VITE_ASSET__DE$1e00a__"